import { Component } from '@angular/core';
import {JasoIndexComponent} from "./jaso-index.component";

@Component({
  selector: 'app-jaso-index-seungjo',
  template: `
    <article class="schedule-navigation">
      <div class="list-box">
        <a *ngIf="mainJaso"
           class="navi-btn return"
           (click)="onClickJasoIdx($event, null)">
        </a>
        <a *ngIf="mainJaso"
           class="navi-btn {{ mainJaso === curJasoIdx ? 'on' : '' }}"
           (click)="onClickJasoIdx($event, mainJaso)">{{ mainJaso }}</a>
        <a *ngFor="let jaso of jasoList"
           class="navi-btn {{ jaso === curJasoIdx ? 'on' : '' }}"
           (click)="onClickJasoIdx($event, jaso)">{{ jaso[0] }}</a>
      </div>

    </article>
  `,
})
export class JasoIndexSeungjoComponent extends JasoIndexComponent {

}
